import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    this.setupIntersectionObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '50px',
      threshold: 0.01
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadImage(entry.target)
          this.observer.unobserve(entry.target)
        }
      })
    }, options)

    this.imageTargets.forEach(img => {
      this.observer.observe(img)
    })
  }

  loadImage(img) {
    const src = img.dataset.src
    const srcset = img.dataset.srcset

    if (src) {
      img.src = src
    }
    
    if (srcset) {
      img.srcset = srcset
    }

    img.classList.add('lazy-loaded')
    img.classList.remove('lazy-loading')
  }
}